module.exports = __webpack_public_path__ + "img/HD_INCOMING_GOODS_1.02a209cc.png";